/**
 * Device Detection Utility
 * Detects device type: mobile, tablet, desktop
 */

import { DEVICE_TYPES } from './constants.js';

/**
 * Detect device type based on viewport width
 * @returns {string} device type: mobile, tablet, or desktop
 */
export function detect_device_type() {
  // SSR-safe check
  if (typeof window === 'undefined') {
    return DEVICE_TYPES.DESKTOP;
  }

  const width = window.innerWidth;

  // Mobile: 0-640px
  if (width < 641) {
    return DEVICE_TYPES.MOBILE;
  }

  // Tablet: 641-1024px
  if (width < 1025) {
    return DEVICE_TYPES.TABLET;
  }

  // Desktop: 1025px+
  return DEVICE_TYPES.DESKTOP;
}

/**
 * Create a responsive device listener
 * Returns callback function to attach to resize event
 * @param {Function} callback - Callback when device type changes
 * @returns {Function} Event handler
 */
export function create_device_listener(callback) {
  if (typeof window === 'undefined') {
    return () => {};
  }

  let current_device = detect_device_type();

  return function handle_resize() {
    const new_device = detect_device_type();
    if (new_device !== current_device) {
      current_device = new_device;
      callback(new_device);
    }
  };
}
